import { render, staticRenderFns } from "./NoInfo.vue?vue&type=template&id=43298b36&scoped=true"
import script from "./NoInfo.vue?vue&type=script&lang=js"
export * from "./NoInfo.vue?vue&type=script&lang=js"
import style0 from "./NoInfo.vue?vue&type=style&index=0&id=43298b36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43298b36",
  null
  
)

export default component.exports